module.exports = __webpack_public_path__ + "static/media/dog.805aba41.svg";